import { render } from "./AspectRatio.vue?vue&type=template&id=040adc92"
import script from "./AspectRatio.vue?vue&type=script&lang=js"
export * from "./AspectRatio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__